<template>
  <div class="groupContainer">
    <div>
      <div v-if="!isHorizontal">{{ field.name }}</div>
      <div v-for="(group, index) in groups" :key="index+'users_group'" class="d-flex align-items-center">
        <div class="w-100" :class="isHorizontal ? 'd-flex' : ''">
          <div class="" style="min-width: 190px">
            <div class="d-flex justify-content-between align-items-center">
              <FacetedSearch
                :options="facetedSearchOptions"
                @search="setFacetedFilters"
                :showOptions="true"
                :optionsToShow="formattedOptions"
                @onSelectOption="onSelectOption"
                :itemIndex="index"
                :isHorizontal="true"
                :disabled="isSelectDisabled || group.soeidNotApply === '1'"
                :showFieldBottom="true"
              />
              <!-- <v-select
                v-model="group.user"
                :options="formattedOptions"
                :filterable="false"
                :multiple="false"
                :clearable="true"
                ref="selectable"
                :placeholder="$t(placeholderTranslation)"
                @search="onSearch"
                @input="onChangeSelect(index)"
                class="w-100 white-bg"
                :disabled="isSelectDisabled || group.soeidNotApply === '1'"
                append-to-body
              >
                <template #list-footer>
                  <li v-if="meta.total > 10" class="pagination">
                    <BButton
                      variant="outline-primary"
                      size="sm"
                      :disabled="!hasPrevPage"
                      @click="prevPage"
                    >
                      <feather-icon icon="ChevronLeftIcon" size="16"/>
                    </BButton>
                    <BButton
                      variant="outline-primary"
                      size="sm"
                      :disabled="!hasNextPage"
                      @click="nextPage"
                    >
                      <feather-icon icon="ChevronRightIcon" size="16"/>
                    </BButton>
                  </li>
                </template>
              </v-select> -->
              <a v-if="showBtnGroup && !isSelectDisabled" role="button" @click="removeGroup(index)" class="btn-remove-group-horizontal mb-1">Remove</a>
            </div>
            <span class="text-error" v-if="error">{{ error }}</span>

          </div>

          <div :class="isHorizontal ? 'd-flex' : ''">
            <div :class="{'mt-1':!isHorizontal}">
              <b-form-group
                class="labelForSelect ml-1"
                style="min-width: 160px">
                <b-form-input
                  id="user_soeid"
                  v-model="group.soeid"
                  @input="onChange"
                  :disabled="group.soeidNotApply === '1' || isSelectDisabled"
                />
                <div class="textHinnt">SOEID</div>
              </b-form-group>
              <b-form-checkbox
                :id="uniqueId+'soeidNotApply'+index"
                v-model="group.soeidNotApply"
                name="soeidNotApply"
                value="1"
                class="text-capitalize ml-1 cursor-pointer mb-1"
                unchecked-value="0"
                @input="onChangeNotApply(index)"
                :disabled="isSelectDisabled"
              >
                {{ $t("operational_security.evaluation.does_not_apply") }}
              </b-form-checkbox>
            </div>
            <b-form-group
              class="labelForSelect ml-1"
              style="min-width: 160px">
              <b-form-input
                id="user_name"
                v-model="group.fullName"
                @input="onChange"
                :disabled="isSelectDisabled"
              />
              <div class="textHinnt">Nombre</div>
            </b-form-group>
            <b-form-group
              class="labelForSelect ml-1"
              style="min-width: 160px">
              <b-form-input
                id="user_profile"
                v-model="group.profile"
                @input="onChange"
                :disabled="isSelectDisabled"
              />
              <div class="textHinnt">Puesto</div>
            </b-form-group>
          </div>
          <hr>
        </div>
      </div>
    </div>
    <button
      v-if="showBtnGroup && !isSelectDisabled"
      @click="addGroup"
      class="addGroupBtn"
      type="button" >
        <span>+ Usuario</span>
    </button>
  </div>
</template>

<script>
import {ref, onMounted, computed, watch} from "@vue/composition-api";
import axios from "@axios";
import {debounce} from "lodash";
import vSelect from "vue-select";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import FacetedSearch from "@/components/FacetedSearch.vue";

export default {
  components: {
    vSelect,
    FacetedSearch
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isHorizontal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {emit}) {
    const { t } = useI18nUtils();
    const entity = 'RH users';
    const endpoint = '/v1/users-rh';
    const placeholderTranslation = 'custom_forms.select_user';
    const defaultUserData = {
      user: null,
      fullName: null,
      profile: null,
      soeid: null,
      soeidNotApply: '0'
    }
    const facetedSearchOptions = [
      {
        label: t('users.search_filters.soeid'),
        value: 'user',
        isArray: false,
      },
      {
        label: t('users.search_filters.email'),
        value: 'email',
        isArray: false,
      },
      {
        label: t('users.search_filters.name'),
        value: 'name',
        isArray: false,
      },
      {
        label: t('users.search_filters.first_name'),
        value: 'first_name',
        isArray: false,
      },
      {
        label: t('users.search_filters.second_name'),
        value: 'second_name',
        isArray: false,
      },
      {
        label: t('users.search_filters.phone_number'),
        value: 'phone_number',
        isArray: false,
      },
    ];
    const buildSuffix = (base, key) => {
      return `${base} [${key}]`;
    }
    const base = props.field.originalName;
    const exFieldSoeid = buildSuffix(base, 'SOEID');
    const exFieldFullName  = buildSuffix(base, 'Nombre');
    const exFieldProfile = buildSuffix(base, 'Puesto');
    const exFields = {
      soeid: exFieldSoeid,
      full_name: exFieldFullName,
      profile: exFieldProfile,
      self: base
    }
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);

    // Pagination
    const search = ref('');
    const limit = ref(8);
    const currentPage = ref(1);
    const meta = ref(null);
    const options = ref([]);
    const isSelectDisabled = ref(false);
    const groups = ref([{...defaultUserData}]);
    const showBtnGroup = ref(false);
    const soeidBackup = ref([]);
    const error = ref([]);
    const facetedFilters = ref({});

    onMounted(async () => {
      isSelectDisabled.value = props.isFormDisabled ?? false;
      showBtnGroup.value = props?.field?.options?.isGroup;
      fetchData();
    });

    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.originalName] || null;
      },
      { immediate: true }
    );

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    function onChangeNotApply(index) {
      if(groups.value[index].soeid !== 'No aplica') {
        const soeidObj = {
          soeid: groups.value[index]?.user?.soeid,
          label: groups.value[index]?.user?.label
        }
        const exists = soeidBackup.value.some(item => item['soeid'] === soeidObj['soeid']);
        if (!exists) {
          soeidBackup.value.push(soeidObj);
        }
      }
      const soeidBackupItem = soeidBackup.value.find(item => item['label'] === groups.value[index]?.user?.label);
      groups.value[index].soeid = groups.value[index].soeidNotApply === '1' ? 'No aplica' : soeidBackupItem?.soeid
      if(groups.value[index].soeidNotApply === '1') {
        groups.value[index].user = null;
      }
      sendModelValue();
    }

    async function fetchData() {
      try {
        const {data} = await axios.get(endpoint, {
          params: {
            q: search.value,
            max: limit.value,
            'page[n]': currentPage.value,
            sortBy: 'id',
            'with[]': 'profile',
            ...facetedFilters.value
          },
        });
        meta.value = data.meta;
        options.value = data.data;
      } catch (error) {
        console.error(`${entity}Select: request error`, error?.response || error);
      }
    }

    // Computed properties
    const formattedOptions = computed(() =>
      (options.value || []).map(u => ({
        value: u.username || u.id,
        label: `${u.soeid || ''} - ${u.full_name}`,
        id: u.id,
        soeid: u.soeid,
        fullName: u.full_name,
        profile: u?.profile?.type
      }))
    );

    const hasNextPage = computed(() => {
      return meta.value ? meta.value.current_page < meta.value.last_page : false;
    });

    const hasPrevPage = computed(() => {
      return meta.value ? meta.value.current_page - 1 > 0 : false;
    });

    // Watchers
    watch(currentPage, fetchData);

    // Methods
    function onChangeSelect(index) {
      if(groups.value[index]?.user) {
        groups.value[index].soeid = groups.value[index].user.soeid
        groups.value[index].fullName = groups.value[index].user.fullName
        groups.value[index].profile = groups.value[index].user.profile
      } else {
        groups.value[index].soeid = null
        groups.value[index].fullName = null
        groups.value[index].profile = null
      }

      sendModelValue();
    }

    function onChange() {
      sendModelValue();
    }

    function sendModelValue() {
      const result = groups.value.map(item => ({
        [exFields.self]: {label: item?.user?.label, value: item?.user?.value},
        [exFields.soeid]: item.soeid,
        [exFields.profile]: item.profile,
        [exFields.full_name]: item.fullName
      }));
      emit("updateData", props.field, result);
    }

    const onSearch = debounce(async (query, loading) => {
      if (query && query.length) {
        loading(true);
        search.value = query;
        currentPage.value = 1;
        await fetchData();
        loading(false);
      } else {
        currentPage.value = 1;
        search.value = '';
        await fetchData();
      }
    }, 500);

    function nextPage() {
      currentPage.value += 1;
    }

    function prevPage() {
      currentPage.value -= 1;
    }

    function addGroup() {
      groups.value.push({...defaultUserData})
      sendModelValue()
    }

    function removeGroup(index) {
      groups.value.splice(index, 1);
      sendModelValue()
    }

    const setFacetedFilters = (filters) => {
      facetedFilters.value = {...filters, ...{advanced_search: true}}
      fetchData();
    };

    const onSelectOption = (val, index) => {
      if(!val) return;
      groups.value[index].user = val;
      onChangeSelect(index)
    };

    return {
      formattedOptions,
      meta,
      placeholderTranslation,
      isSelectDisabled,
      hasNextPage,
      hasPrevPage,
      onSearch,
      groups,
      showBtnGroup,
      error,
      uniqueId,
      facetedSearchOptions,
      nextPage,
      onChange,
      prevPage,
      addGroup,
      removeGroup,
      onChangeSelect,
      onChangeNotApply,
      setFacetedFilters,
      onSelectOption
    }
  }
}
</script>
<style scoped lang="scss">
.dark-layout {
  .labelForSelect {
    color: #fff
  }
  .addGroupBtn {
    border-color: #fff;
  }
  .textHinnt {
    color: #d3d3d3;
  }
}
.addGroupBtn {
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.65em;
  margin: 0;
  border-color: #53dac5;
  background-color: #53dac5;
  cursor: pointer;
  font-size: 0.75em;
  color: #fff;
  font-weight: bold;
}
.labelForSelect {
  display: block;
  line-height: 1.5;
  font-size: 0.9em;
  font-weight: 600;
  color: #5e5873;
  text-transform: none !important;
  margin-bottom: 0.4em;
}
.input-group-repeatable-remove {
  background-color: #cecece;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 1.35em;
  height: 1.35em;
  transition: background-color 0.2s;
}
.input-group-repeatable-remove:hover {
  background-color: #dc2c2c;
}

.input-group-repeatable-remove::before,
.input-group-repeatable-remove::after {
  content: "";
  position: absolute;
  left: 50%;
  width: 0.80em;
  height: 0.2em;
  background-color: white;
  transform-origin: center center;
  transition: transform 0.3s ease;
}

.input-group-repeatable-remove::before {
  top: 40%;
  transform: translateX(-50%);
}

.input-group-repeatable-remove::after {
  top: 40%;
  transform: translateX(-50%);
}

.input-group-repeatable-remove:hover::before {
  top: 42%;
  transform: translateX(-60%) rotate(45deg);
}

.input-group-repeatable-remove:hover::after {
  top: 42%;
  transform: translateX(-60%) rotate(-45deg);
}
.groupContainer {
  // padding: 1em;
  // border: 1px solid #efefef;
  border-radius: 0.3em;
}
.text-error {
  color: #ec0303;
}
.textHinnt {
  color: #5e5873;
  font-size: 1em;
  margin-top: 5px;
}
.white-bg {
  background-color: #fff;
}
.btn-remove-group-horizontal {
  position: relative;
  color: transparent !important;
  margin: 0 0 0px 15px;
  border: 1px solid #e74c3c !important;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s;
}
.btn-remove-group-horizontal::after {
  content: "Eliminar";
  color: #fff;
  position: absolute;
  top: 4px;
  left: 12px;
  color: #e74c3c !important;
}
.btn-remove-group-horizontal:hover {
  background: #ffecec !important;
}
</style>
